import { render } from "./LoginButton.vue?vue&type=template&id=bb34049e&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=js"
export * from "./LoginButton.vue?vue&type=script&lang=js"

import "./LoginButton.vue?vue&type=style&index=0&id=bb34049e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb34049e"]])

export default __exports__